let csrfToken: string | null = null
let onSessionExpired: (() => void) | undefined

export function setCSRFToken(token: string | null): void {
  csrfToken = token
}

export function getCSRFToken(): string | null {
  return csrfToken
}

export function onAdminSessionExpired(callback: () => void): void {
  onSessionExpired = callback
}

export async function adminFetch(input: RequestInfo | URL, init: RequestInit = {}): Promise<Response> {
  const request = input instanceof Request ? input : undefined
  const url = new URL(request?.url ?? String(input), window.location.origin)
  if (url.origin !== window.location.origin || !url.pathname.startsWith('/api/')) {
    throw new Error('Admin requests must use the same-origin API')
  }
  const method = (init.method ?? request?.method ?? 'GET').toUpperCase()
  const headers = new Headers(init.headers ?? request?.headers)
  if (!['GET', 'HEAD', 'OPTIONS'].includes(method) && csrfToken) {
    headers.set('X-CSRF-Token', csrfToken)
  }
  const response = await fetch(input, { ...init, headers, credentials: 'same-origin' })
  if (response.status === 401) {
    csrfToken = null
    onSessionExpired?.()
  }
  return response
}

export async function adminRequest<T>(path: string, init: RequestInit = {}): Promise<T> {
  const headers = new Headers(init.headers)
  if (init.body) headers.set('Content-Type', 'application/json')
  const response = await adminFetch(`/api/admin-auth${path}`, { ...init, headers })
  if (response.status === 204) return undefined as T
  const data = await response.json()
  if (!response.ok) throw new Error(data.error || 'Request failed')
  return data as T
}
